import { EnumFunnelTrackingCookies, setCookieWithFallback, } from '@core/tracking/funnelTracking';
/**
 *
 */
export function persistVideoId(encodedVideoId) {
    setCookieWithFallback(EnumFunnelTrackingCookies.FW_LAST_VIDEO_ID, encodedVideoId);
}
